module.exports = __webpack_public_path__ + "img/50.5163e877.jpg";